import httpClient from "../Core/http";

class Gateway_Api {
  getCustomerGatewayInfo(params: any, signal: any): Promise<any> {
    let url = "customers/gatewayInfo";
    return new Promise((resolve, reject) => {
      httpClient
        .get<any[]>(url, { params: params, signal: signal })
        .then((response: any) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
          console.log(error);
        });
    });
  }

  getMachineGatewayInfo(params: any, signal: any): Promise<any> {
    let url = "customers/machineGatewayInfo";
    return new Promise((resolve, reject) => {
      httpClient
        .get<any[]>(url, { params: params, signal: signal })
        .then((response: any) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
          console.log(error);
        });
    });
  }
}

export const GatewayApi = new Gateway_Api();
